import { Keys, type PostKeys, type PostSignUp } from '@/models/login';
import { apiClient } from './apiClient';

class LoginService {

  initService() {}

  async loginUser(keysData: PostKeys) {
    // Unsigned by definition — this is the call that fetches the keys everything else signs with.
    const uri = `/keys/oauth`;
    const res = await apiClient.post(uri, keysData);
    return Keys.mapKeys(res.data);
  }

  async signUp(signUpData: PostSignUp) {
    const uri = `/user`;
    const res = await apiClient.post(uri, signUpData);
    return res.data;
  }
}

export default new LoginService();
